var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"flat":"","icon":"","color":"white"},on:{"click":_vm.share}},[_c('fa-icon',{staticStyle:{"color":"#3b5999"},attrs:{"icon":['fab', 'facebook-f'],"fixed-width":"","size":"lg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }